import { useNavigate } from 'react-router-dom'

const PrivateComponent = (props) => {

    const navigate = useNavigate()

    const localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
    const token = localuser.token || localStorage.getItem('MemberAuth')

    if (!token) {
        navigate('/admin/login')
        return null
    }

    return props.element
}

export default PrivateComponent